/*exported showField, say, rotate, hsm */
import $ from 'jquery';
import * as Browser from 'leaflet/src/core/Browser';
import { Map } from 'leaflet/src/map/Map';
import { LayerGroup } from 'leaflet/src/layer/LayerGroup';
import * as DomEvent from 'leaflet/src/dom/DomEvent';
import { SimpleY } from 'leaflet/CRS/SimpleY';
import { MyZoom } from 'leaflet/Control/MyZoom';
import { Pages } from 'leaflet/Control/Pages';
import log from 'log';
import * as Overlay from 'overlay';
import * as Doc from 'doc';
import * as Panel from 'panel';
import * as Sign from 'sign';
import * as Annotations from 'annotations';
import Canvas from 'canvas';
import Doodle from 'doodle';
import state from 'state';

state.panel.sign = $('#sigPanel');
state.panel.search = $('#searchPanel');
state.panel.annot = $('#annotPanel');

export function selectInitialFile() {
    if (state.hash != window.location.hash) {
        var param = window.location.hash.slice(1).split(','),
            newFile = parseInt(param[0] || '', 10) || 0,
            newPage = parseInt(param[1] || '', 10) || 1;
        Doc.changeFile(newFile, false, newPage - 1);
    }
}

function parseToken() {
    //jshint regexdash: true
    var reTok = /token=([0-9A-Za-z-]+)/.exec(window.location.search);
    if (!reTok)
        Overlay.error('Mandatory parameter "token" is missing.', false);
    return reTok[1];
}

log('web2sign ' + $('#release').data('unique') + ' is loading');
state.token = parseToken();
$('#custom').on('click dblclick mousedown', function (e) {
    // avoid events started in the "custom" DIV to reach the map
    e.stopPropagation();
});
var options = $('#options');
if (!Browser.retina)
    $('input[value="+1"]', options).parent().remove();
$('input[name="resolution"][value="' + (0|localStorage.w2s_zoomOffset) + '"]', options).prop('checked', true);
$('input[name="resolution"]', options).change(function () {
    localStorage.w2s_zoomOffset = 0|this.value;
    Doc.changePage(state.page, true);
});
Panel.setup(state.panel.sign);
Panel.setup(state.panel.search);
Panel.setup(state.panel.annot);
// load map
state.map = new Map('map', {
    attributionControl: false,
    zoomControl: false,
    crs: SimpleY,
    zoomSnap: 0.25,
    zoomDelta: 0.25
});
new MyZoom().addTo(state.map);
new Pages().addTo(state.map);
//TODO: move each layer to his own file
Doc.layer.page = new LayerGroup().addTo(state.map);
Doc.layer.sigs = new LayerGroup().addTo(state.map);
Doc.layer.form = new LayerGroup().addTo(state.map);
Doc.layer.search = new LayerGroup().addTo(state.map);
Doc.layer.annot = new LayerGroup().addTo(state.map);
state.map.on('popupopen', Sign.managePopups);
$('#butAbout').click(Overlay.about);
$('#pagePrev').click(function () { Doc.changePage(state.page - 1); });
$('#pageNext').click(function () { Doc.changePage(state.page + 1); });
var pageText = $('.leaflet-control-pages-number input')[0];
$(document).keyup(function (e) {
    if (e.isDefaultPrevented() || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey)
        return;
    if (window.HTMLInputElement && e.target instanceof HTMLInputElement)
        return;
    if (window.HTMLTextAreaElement && e.target instanceof HTMLTextAreaElement)
        return;
    var block = true;
    switch (e.which) {
    case 27: // Escape
        if (state.panel.sign.isOpen())
            state.panel.sign.close();
        if (state.panel.search.isOpen())
            state.panel.search.close();
        break;
    case 33: // PgUp
        Doc.changePage(state.page - 1);
        break;
    case 34: // PgDn
        Doc.changePage(state.page + 1);
        break;
    case 72: // h
    case 86: // v
    case 80: // p
        Doc.fitPage();
        break;
    case 87: // w
        Doc.fitWidth();
        break;
    case 83: // s
        state.panel.sign.toggleOpen(); //TODO: only if it's visible
        break;
    case 70: // f
        state.panel.search.toggleOpen();
        break;
    case 49: // 1
    case 50: // 2
    case 51: // 3
    case 52: // 4
    case 53: // 5
    case 54: // 6
    case 55: // 7
    case 56: // 8
    case 57: // 9
        pageText.showWithPage(e.which - 48);
        break;
    default:
        block = false;
    }
    if (block)
        e.preventDefault();
}).on('contextmenu', function (e) {
    DomEvent.stopPropagation(e);
    DomEvent.preventDefault(e);
    return false;
});
try {
    state.canvas = new Canvas();
} catch (e) {
    log('Canvas fail', e);
}
try {
    state.doodle = new Doodle();
} catch (e) {
    log('Doodle fail', e);
}
if ('onhashchange' in window)
    window.onhashchange = selectInitialFile;
$.getJSON('pdf/' + state.token + '/0/general.json'
).then(function (data) {
    // check if there is a blocking error to show
    if (data.error)
        Overlay.error(data.error, false);
    // disable features
    var feature = state.feature = data.feature;
    if (feature.search === false)
        state.panel.search.hide();
    if (feature.signature === false)
        state.panel.sign.hide();
    if (feature.annotation === false && feature.doodle === false)
        state.panel.annot.hide();
    else
        Annotations.activate();
    // shows list of filenames (if needed)
    state.hsm = data.hsm;
    state.tileSize = 0|data.tileSize;
    Doc.updateFiles(data);
    // load store-specific hook script
    var hook = document.createElement('script');
    hook.type = 'text/javascript';
    hook.src = 'pdf/' + state.token + '/0/script.js';
    document.getElementById('scripts').appendChild(hook);
    // the hook will call selectInitialFile();
}).catch(function () {
    Overlay.error('Error accessing document, probably the token has expired.', false);
});
